import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  key: 0,
  id: "main-content-port"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad20" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "オーナーのみが受け取れる通知設定"),
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"50px"} }),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_6 = {
  key: 0,
  class: "fl w60 mt20"
}
const _hoisted_7 = ["for"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { class: "w90 pad15" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, " ")
], -1)
const _hoisted_11 = { class: "fl w65" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_UserSettingsHeader = _resolveComponent("UserSettingsHeader")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `settings` }),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createVNode(_component_UserSettingsHeader, {
                selectedTab: _ctx.selectedTab,
                ref: "header"
              }, null, 8, ["selectedTab"]),
              _hoisted_5,
              (_ctx.myNotifications)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.additionalTimings), (timing) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${timing}_${_ctx.myNotifications}`,
                        class: "",
                        style: {"width":"200px","margin-top":"25px"}
                      }, [
                        _createVNode(_component_CheckboxTag, {
                          value: timing,
                          name: _ctx.additionalTimings[timing],
                          checked: _ctx.myNotifications.includes(timing),
                          prefix: `${_ctx.myUser ? `${_ctx.myUser.id}` : `A`}`,
                          onClickCheckbox: _ctx.clickTiming
                        }, null, 8, ["value", "name", "checked", "prefix", "onClickCheckbox"]),
                        _createElementVNode("label", {
                          for: `${_ctx.myUser ? `${_ctx.myUser.id}` : `A`}_${timing}`,
                          class: "fs12 fw600"
                        }, _toDisplayString(_ctx.additionalTimings[timing]), 9, _hoisted_7)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _hoisted_8,
              _createElementVNode("section", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "pointer centered circle_button skyblueBg fs16",
                    style: {"width":"340px","padding":"8px 5px","max-width":"98%"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveNotification && _ctx.saveNotification(...args)))
                  }, " 保存 ")
                ]),
                _hoisted_12
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_13
    ])
  ]))
}